/*
import React, { useState, useEffect } from "react";
import { getFirestore, doc, deleteDoc } from "firebase/firestore";
import { getStorage, ref, listAll, deleteObject } from "firebase/storage";
import Modal from "../../shared/components/Modal";
import toastService from "../services/toastService";

const DeletePatient = ({
  isOpen,
  onClose,
  selectedPatient,
  resetSelectedPatient,
}) => {
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setConfirmChecked(false);
    }
  }, [isOpen]);

  const handleDelete = async () => {
    if (!confirmChecked) {
      toastService.showError("Debes marcar la casilla de confirmación.");
      return;
    }

    if (!selectedPatient) {
      toastService.showError("No hay un paciente seleccionado.");
      return;
    }

    try {
      setLoading(true);
      const db = getFirestore();
      const storage = getStorage();

      const patientFolderRef = ref(
        storage,
        `patientFiles/${selectedPatient.id}/`
      );

      const fileList = await listAll(patientFolderRef);

      const deletePromises = fileList.items.map((fileRef) =>
        deleteObject(fileRef)
      );
      await Promise.all(deletePromises);

      await deleteDoc(doc(db, "registeredPatients", selectedPatient.id));

      toastService.showSuccess(
        "El paciente y sus archivos han sido eliminados correctamente."
      );
      resetSelectedPatient();
      onClose();
    } catch (error) {
      toastService.showError(
        "Ocurrió un error al eliminar el paciente y sus archivos."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2>Eliminar paciente</h2>
      {!selectedPatient ? (
        <p>
          No hay ningún paciente seleccionado. Selecciona uno antes de eliminar.
        </p>
      ) : (
        <>
          <p>
            ¿Confirmas que deseas eliminar a{" "}
            <strong>
              {selectedPatient.name} {selectedPatient.surname}
            </strong>
            ?
          </p>
          <div style={{ margin: "10px 0" }}>
            <input
              type="checkbox"
              id="confirmDelete"
              checked={confirmChecked}
              onChange={() => setConfirmChecked(!confirmChecked)}
            />
            <label htmlFor="confirmDelete" style={{ marginLeft: "5px" }}>
              Reconozco que se eliminarán todos los datos personales,
              evoluciones, antecedentes y archivos de este paciente.
            </label>
          </div>
          <button
            onClick={handleDelete}
            className="smallButton"
            disabled={!confirmChecked || loading}
          >
            {loading ? "Eliminando..." : "Eliminar"}
          </button>
        </>
      )}
    </Modal>
  );
};

export default DeletePatient;
*/

import React, { useState, useEffect } from "react";
import { getFirestore, doc, deleteDoc } from "firebase/firestore";
import { auth } from "../../shared/firebase/firebase";
import Modal from "../../shared/components/Modal";
import toastService from "../services/toastService";

const DeletePatient = ({
  isOpen,
  onClose,
  selectedPatient,
  resetSelectedPatient,
}) => {
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setConfirmChecked(false);
    }
  }, [isOpen]);

  const handleDelete = async () => {
    if (!confirmChecked) {
      toastService.showError("Debes marcar la casilla de confirmación.");
      return;
    }

    if (!selectedPatient) {
      toastService.showError("No hay un paciente seleccionado.");
      return;
    }

    try {
      setLoading(true);

      const token = await auth.currentUser.getIdToken();

      const response = await fetch(
        "https://deletepatientfiles-gdgxgwdpxq-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            patientId: selectedPatient.id,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Error al borrar archivos");
      }

      const db = getFirestore();
      await deleteDoc(doc(db, "registeredPatients", selectedPatient.id));

      toastService.showSuccess(
        "El paciente y sus archivos han sido eliminados correctamente.",
      );

      resetSelectedPatient();
      onClose();
    } catch (error) {
      console.error("DeletePatient:", error);
      toastService.showError(
        "Ocurrió un error al eliminar el paciente y sus archivos.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2>Eliminar paciente</h2>

      {!selectedPatient ? (
        <p>
          No hay ningún paciente seleccionado. Selecciona uno antes de eliminar.
        </p>
      ) : (
        <>
          <p>
            ¿Confirmas que deseas eliminar a{" "}
            <strong>
              {selectedPatient.name} {selectedPatient.surname}
            </strong>
            ?
          </p>

          <div style={{ margin: "10px 0" }}>
            <input
              type="checkbox"
              id="confirmDelete"
              checked={confirmChecked}
              onChange={() => setConfirmChecked(!confirmChecked)}
            />
            <label htmlFor="confirmDelete" style={{ marginLeft: "5px" }}>
              Reconozco que se eliminarán todos los datos personales,
              evoluciones, antecedentes y archivos de este paciente.
            </label>
          </div>

          <button
            onClick={handleDelete}
            className="smallButton"
            disabled={!confirmChecked || loading}
          >
            {loading ? "Eliminando..." : "Eliminar"}
          </button>
        </>
      )}
    </Modal>
  );
};

export default DeletePatient;
